
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import type { SubscriptionTransaction } from "@/types/subscription";

export const useSubscriptionTransactions = (userId?: string) => {
  return useQuery<SubscriptionTransaction[]>({
    queryKey: ["subscription-transactions", userId],
    queryFn: async () => {
      if (!userId) return [];

      const { data, error } = await supabase
        .from('subscription_transactions')
        .select('*')
        .eq('status', 'completed')
        .order('created_at', { ascending: false });

      if (error) throw error;
      return data as SubscriptionTransaction[];
    },
    enabled: !!userId
  });
};
